<template>
  <div v-if="plate && !isLoading">
    <v-checkbox
      v-model="plate.isPrimaryBeneficiary"
      label="And who's going to be the primary Beneficiary?"
      :error="$v.plate.isPrimaryBeneficiary.$error"
    />

    <div class="my-4">
      <div class="row">
        <BeneficiaryForm
          v-for="(beneficiary, k) in primaryBeni"
          :key="k"
          class="beneficiary col-5 ml-6 mb-6"
          :beneficiary="beneficiary"
          :removeBeneficiary="removePrimaryBeni(k, beneficiary.id)"
        />

        <v-card
          class="beneficiary d-flex align-center justify-center col-5 ml-6 mb-6"
        >
          <div
            @click="addPrimaryBeni"
            role="button"
            class="d-flex align-center"
          >
            <h4 class="mr-4">Add another</h4>
            <v-btn color="success" small fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>

    <v-checkbox
      v-model="plate.isContingentBeneficiary"
      label="Would you like a contingent Beneficiary?"
      :error="$v.plate.isContingentBeneficiary.$error"
    />

    <div v-if="plate.contingentBeneficiary" class="my-4">
      <div class="row">
        <BeneficiaryForm
          v-for="(beneficiary, k) in contingentBeni"
          :key="k"
          class="beneficiary col-5 ml-6 mb-6"
          :beneficiary="beneficiary"
          title="Contingent Beneficiary"
          :removeBeneficiary="removeContingentBeni(k, beneficiary.id)"
        />

        <v-card
          class="beneficiary d-flex align-center justify-center col-5 ml-6 mb-6"
        >
          <div
            @click="addContingentBeni"
            role="button"
            class="d-flex align-center"
          >
            <h4 class="mr-4">Add another</h4>
            <v-btn color="success" small fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>

    <v-radio-group v-model="plate.contingentBeneficiary" row>
      <v-radio :value="true" label="Yes" />
      <v-radio :value="false" label="No" />
    </v-radio-group>

    <v-checkbox
      v-model="plate.isClaim"
      label="It's easy to claim the death benefit. Your Beneficiary would submit
       needs two forms of ID and the death certificate. Then the claim is paid 100% tax fee."
      :error="$v.plate.isClaim.$error"
    />

    <v-checkbox
      v-model="plate.isEnsure"
      :label="`This will ensure they can take care of:`"
      :error="$v.plate.isEnsure.$error"
    />

    <div class="my-4 ml-8">
      <div class="d-flex mb-2 body-1" v-for="(type, k) in needsList" :key="k">
        <div class="mr-2">-</div>
        <div>{{ needDetails(type) }}</div>
      </div>
    </div>

    <v-checkbox
      v-model="plate.isSense"
      :error="$v.plate.isSense.$error"
      label="Does that make sense?"
    />

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps, ProtectionTypes } from '@/common/variables';
import { isChecked } from '@/common/helpers';
import BeneficiaryForm from '@/components/lead/plates/BeneficiaryForm';
import axios from 'axios';

export default {
  name: 'BeneficiaryPlate',
  components: { BeneficiaryForm, PlateFooter },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      needs: 'plates/needs',
      needsList: 'plates/needsList',
    }),
  },
  data() {
    return {
      plate: null,
      isLoading: null,
      emptyBeni: {
        name: null,
        relative_id: null,
        percent: null,
        dob: null,
        number: 1, //123
      },
      primaryBeni: [],
      contingentBeni: [],
      currentLead: {},
    };
  },
  mounted() {
    this.loadBeneficiaries();
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.beneficiary
    );
    this.plate = data;
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: 'snackbar/showHandlerSnackbar',
    }),
    async loadBeneficiaries() {
      try {
        this.isLoading = true;
        const { data } = await axios('/beneficiaries/' + this.lead.id);

        data.beneficiaries.forEach((beneficiary) => {
          beneficiary.type_id == 1
            ? this.primaryBeni.push({
                ...beneficiary,
                number: this.primaryBeni.length + 1,
              })
            : this.contingentBeni.push({
                ...beneficiary,
                number: this.contingentBeni.length + 1,
              });
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }
    },
    async savePrimaryBeneficiaries() {
      const beneficiariesPromises = [];
      await this.primaryBeni.forEach((beneficiary) => {
        const { name, relative_id, percent, dob, number } = beneficiary;
        
        beneficiariesPromises.push(
          axios.put(
            `/beneficiaries/lead/${this.lead.id}/type/1/number/${number}`,
            { name, relative_id, dob, percent }
          )
        );
      });

      await Promise.all(beneficiariesPromises)
        .then((data) => {
          console.log(data);
        })
        .catch((e) => {
          this.showHandlerSnackbar({
            color: 'error',
            text: e.response.data.message,
            show: true,
          });
        });
    },
    async saveContingentBeneficiaries() {
      const beneficiariesPromises = [];
      await this.contingentBeni.forEach((beneficiary) => {
        const { name, relative_id, percent, dob, number } = beneficiary;
        console.log({ name, relative_id, percent, dob, number });
        beneficiariesPromises.push(
          axios.put(
            `/beneficiaries/lead/${this.lead.id}/type/2/number/${number}`,
            { name, relative_id, dob, percent }
          )
        );
      });

      await Promise.all(beneficiariesPromises)
        .then((data) => {
          console.log(data);
        })
        .catch((e) => {
          this.showHandlerSnackbar({
            color: 'error',
            text: e.response.data.message,
            show: true,
          });
        });
    },
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.email);
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        await this.saveContingentBeneficiaries();
        await this.savePrimaryBeneficiaries();

        this.$store.commit('plates/setStep', PlatesSteps.payment);
        await this.$store.dispatch('plates/updatePlate', this.lead);
      } catch (e) {
        alert(e.response.data.message);
      }
    },
    addPrimaryBeni() {
      this.primaryBeni = [
        ...this.primaryBeni,
        { ...this.emptyBeni, number: this.primaryBeni.length + 1 },
      ];
    },
    removePrimaryBeni(number, index) {
      return () => {
        if (!index) {
          return this.primaryBeni = this.primaryBeni.filter((_, i) => i !== number);
        }

        axios.delete(`beneficiaries/${index}`)
        .then(() => {
          this.primaryBeni = this.primaryBeni.filter((_, i) => i !== number);
        })

      };
    },
    addContingentBeni() {
      this.contingentBeni = [
        ...this.contingentBeni,
        {
          ...this.emptyBeni,
          number: this.contingentBeni.length + 1,
        },
      ];
    },
    removeContingentBeni(number, index) {
      return () => {
        if (!index) {
          return this.contingentBeni = this.contingentBeni.filter((_, i) => i !== number);
        }

        axios.delete(`beneficiaries/${index}`)
        .then(() => {
          this.contingentBeni = this.contingentBeni.filter((_, i) => i !== number);
        })
      };
    },
    needDetails(type) {
      const protection = this.needs[type];

      switch (type) {
        case ProtectionTypes.debt:
          return `We DO need Debit protection, to avoid the reassigning
              of debits or collections. You have ${protection.amount} you'd like covered.`;

        case ProtectionTypes.mortgage:
          return `We do need mortgage protection, to make sure they'll have a
              roof over their head. You have ${protection.amount} left on the house
              with roughly ${protection.yearsLeft} years`;

        case ProtectionTypes.family: {
          const collegeText = `${protection.collegeExpenses ? 'Is' : 'Isn`t'}
           important to take care of college expenses`;

          const childrenText = `${
            protection.isAnyChildren
              ? `${protection.childrenCount} young ones, the youngest being
              ${protection.childrenAge} years old and it ${collegeText}`
              : ''
          }`;

          return `We ${protection.replacement ? 'Do' : 'Don`t'} need income
              replacement, to supplement the loss earning they would experience.
              You ${protection.isAnyChildren ? 'Do' : 'Don`t'} have children.
              ${childrenText}`;
        }

        case ProtectionTypes.finalExpenses: {
          const relationText =
            this.beneficiary.relationship === 'spouse'
              ? `I know ${this.beneficiary.name} is a ${this.beneficiary.status}. We
                want them to focus on your memory.`
              : `I know ${this.beneficiary.name} gave you ${
                  this.beneficiary.grandchildrenAmount
                }
                grandkids and ${
                  this.beneficiary.liveInSameState ? "won't" : 'will'
                }
                have to travel from out of town. We want them to focus on you and
                your memory.`;

          return `${this.lead.firstname}, you want to make sure ${this.beneficiary.name}
            doesn't have to come out of pocket for the ${protection.target}. ${relationText}`;
        }

        default:
          return '';
      }
    },
  },
  validations: {
    plate: {
      isPrimaryBeneficiary: { checked: isChecked },
      isContingentBeneficiary: { checked: isChecked },
      isClaim: { checked: isChecked },
      isEnsure: { checked: isChecked },
      isSense: { checked: isChecked },
    },
  },
};
</script>

<style scoped lang="scss">
.form-input {
  padding: 0 !important;
  margin: 0 0 0 1em !important;
}

.beneficiary {
  min-height: 270px;
}
</style>